module.exports = __webpack_public_path__ + "img/ordered-list.735619e1.svg";